module.exports = "/images/closewhite.svg";